export default __webpack_public_path__ + "static/media/04_skolkovani-semenacku.78807d97.jpg";